import { ExportHistoryEntry, IExportsApiCall, IRestApiService } from '../types';

// Generic - not tied to any one feature module, mirrors apps/server/src/exports/exports.route.ts
// (the shared status/download/history endpoints every background export type registers against).
class ExportsApiCall implements IExportsApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getExportHistory(): Promise<ExportHistoryEntry[]> {
    return this.restApiService
      .get<{ history: ExportHistoryEntry[] }>('exports/history')
      .then((response) => response.history);
  }
}

export default ExportsApiCall;
